import {
  Select,
  Splitter,
  Row,
  Col,
  Typography,
  Spin,
  Alert,
  Button,
  Modal,
  message,
  Divider,
  Tooltip
} from "antd";
import BuilderTools from "../invoicebuilder/components/BuilderTools";
import configs from "./components/configs.json";
import TemplatePreview from "../invoicebuilder/components/PreviewTemplate";

import React, { useState } from "react";
import { Segmented } from "antd";
import { FolderOpenOutlined,SaveOutlined, MobileOutlined, DesktopOutlined, LinkOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { appendDefaultValues } from "../invoicebuilder/components/preprocessProductpageData";

import ProductPageRentalPicker from "../atoms/rentlog/ProductPageRentalPicker";

import {
  getProductPageConfig,
  getRentals,
  setRentalCache,
  setProductPageConfig,
  updateRentalCache,
} from "../../interfaces/productPageInterface";

const { Title, Text } = Typography;

function ProductpageHeader({ setAddProduct, onChangeView, onSaveConfig }) {
  const [view, setView] = useState("desktop");
  useEffect(() => {
    onChangeView(view);
  }, [view]);

  function openProductPage() {
    const workspaceId = sessionStorage.getItem('selectedWorkspace');
    if (!workspaceId) {
      console.error("No workspace selected");
      return;
    }
    const { protocol, hostname } = window.location;
    // Force port 5001 only for localhost
    const port = hostname === "localhost" ? "5001" : window.location.port;
    const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ""}`;
    const url = `${baseUrl}/product/${workspaceId}`;
    window.open(url, "_blank");
  }
  return (
    <>
    <div
      style={{
        padding: "10px 10px",
        background: "rgba(255,255,255,0.9)",
        borderBottom: "1px solid #eee",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backdropFilter: "blur(8px)",
      }}
    >
      {/* LEFT */}
      <div>
        <Title level={4} style={{ margin: 0 }}>
          Customize your product page layout
        </Title>
        <Text type="secondary">
          Preview how your page renders across devices
        </Text>

      </div>

      {/* RIGHT */}
      <div style={{ display: "flex", gap: 10 }}>
  <Segmented
    value={view}
    onChange={setView}
    options={[
      { label: <><DesktopOutlined /> Desktop</>, value: "desktop" },
      { label: <><MobileOutlined /> Mobile</>, value: "mobile" },
    ]}
  />

  <Divider type="vertical" style={{ height: 28, margin: "auto 2px" }} />

  <Button type="primary" icon={<PlusOutlined />} onClick={() => setAddProduct(true)}>
    Add rentals
  </Button>

  <Tooltip title="Made changes to a rental on this page? Click to refresh visitor-facing content.">
    <Button
      icon={<ReloadOutlined />}
      onClick={async() => {
        message.info("Updating cache in the background. This may take a few minutes.");
        await updateRentalCache();
      }}
    >
      Update cache
    </Button>
  </Tooltip>

  <Button
    style={{ background: "#f97316", borderColor: "#f97316", color: "#fff" }}
    icon={<LinkOutlined />}
    onClick={openProductPage}
  >
    Preview
  </Button>

  <Button
    style={{ background: "#16a34a", borderColor: "#16a34a", color: "#fff" }}
    icon={<SaveOutlined />}
    onClick={onSaveConfig}
  >
    Save config
  </Button>
</div>

    </div>

</>
  );
}

const ProductPage = () => {
  const [currency, setCurrency] = useState();
  const [addProduct, setAddProduct] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [rentalsData, setRentalsData] = useState({});
  const [rentalSearch, setRentalSearch] = useState("");
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(false);
  const [unsaved, setUnsaved] = useState(false);
  const setValue = (dataField, value) => {
    if(dataField !== "mobileview"){
      setUnsaved(true)
    }
    let prevPreviewData = { ...previewData };
    prevPreviewData[dataField] = value;

    setPreviewData(prevPreviewData);
  };
  const onChangeView = (val) => {
    if (val == "desktop") {
      setValue("mobileview", false);
    } else {
      setValue("mobileview", true);
    }
  };
  const onSaveConfig = async () => {
    await setProductPageConfig(previewData, config?.id);
    setUnsaved(false)
    message.success("Saving config")
  };
  const loadRentals = (page, search = "") => {
    setLoading(true);
    getRentals(search).then((data) => {
      setRentalsData({ ...rentalsData, [page]: data });
      setLoading(false);
    });
  };
  useEffect(() => {
    if (addProduct) {
      loadRentals(1);
    }
  }, [addProduct]);
  useEffect(() => {
    setLoading(true)
    getProductPageConfig().then((data) => {
      data = data?.[0];
      setConfig(data);
      let values = { ...data?.config };
      if(values.mobileview){
        setValue("mobileview", values.mobileview);
      }
      Object.keys(configs).map((item) => {
        for (let entries of configs[item]) {
          if (!(entries["dataField"] in values))
            values[entries["dataField"]] = "";
        }
      });
      setPreviewData(appendDefaultValues(values));
      setLoading(false)
    });
  }, []);
  console.log(rentalsData);
  return (
    <>
      <Spin spinning={loading} description={"Please wait"}  >
      <Modal
        title={"Add Rentals"}
        width={"70%"}
        footer={null}
        open={addProduct}
        onCancel={() => setAddProduct(false)}
      >
        <ProductPageRentalPicker
          products={Object.values(rentalsData).flat()}
          onLoadMore={(page) => {
            loadRentals(page);
          }}
          onSearch={(inp) => {
            setRentalSearch(inp);
            loadRentals(1, inp);
          }}

          selectedProducts={!Array.isArray(config?.rentalsCache)? [] : config?.rentalsCache }
          loading={loading}
          onConfirm={async(rentals) => {
            await setRentalCache(rentals, config?.["id"]);
            setAddProduct(false);
            message.info("Adding your rentals & Updating the Cache in the background . This might take few minutes")
            await updateRentalCache()
          }}
        />
      </Modal>

      <ProductpageHeader
        setAddProduct={setAddProduct}
        onChangeView={onChangeView}
        onSaveConfig={onSaveConfig}
      />

      <Splitter style={{ height: "100vh" }}>
        {/* LEFT PANEL - Builder */}
        <Splitter.Panel
          defaultSize="35%"
          min="35%"
          max="40%"
          style={{ padding: 10, overflowY: "auto" }}
        >
              <Alert
  style={{ marginBottom: 10,marginTop: 10, borderLeft: "2px solid #f97316", borderRadius: "0 8px 8px 0" }}
  type="info"
  showIcon
  message={
    <Typography.Text style={{ fontSize: 12 }}>
      Whenever you make changes to a rentals (eg. Images , Rental amount or quantity), click{" "}
      <strong>Update cache</strong> to ensure visitors see the latest information.
    </Typography.Text>
  }
/>
          {
              <>
            <Row>
              {unsaved && (
                <Alert
                  className="w-full mt-2"
                  type="warning"
                  showIcon
                  style={{marginBottom:10}}
                  message="Config has Unsaved Changes. Save by clicking the save config button in top-right corner of the screen"
                />
              )}
            </Row>

            </>
          }

          <BuilderTools
            key={"productpage"}
            config={configs}
            setPreviewData={setPreviewData}
            setValue={setValue}
            values={previewData}
          />
        </Splitter.Panel>

        {/* RIGHT PANEL - Preview */}
        <Splitter.Panel
          defaultSize="65%"
          min={300}
          style={{ padding: 10, overflow: "auto" }}
        >
          <TemplatePreview
            inIFrame={true}
            runscripts={true}
            url={"/api/template/productpage"}
            previewData={previewData}
            currency={currency}
          />
        </Splitter.Panel>
      </Splitter>
      </Spin>
    </>
  );
};

export default ProductPage;
